import invariant from 'tiny-invariant';

export interface Config {
  API_URI: string;
  BRANCH_API_KEY?: string;
  BRAZE_API_KEY?: string;
  GRAPHQL_URI: string;
  NODE_ENV?: string;
  SEGMENT_API_KEY?: string;
  SENTRY_DSN?: string;
  SPLIT_API_KEY?: string;
  LOG_LEVEL?: string;
  FIREBASE_API_KEY?: string;
  FIREBASE_AUTH_DOMAIN?: string;
  FIREBASE_DATABASE_URL?: string;
  FIREBASE_PROJECT_ID?: string;
  FIREBASE_STORAGE_BUCKET?: string;
  FIREBASE_MESSAGING_SENDER_ID?: string;
  FIREBASE_APP_ID?: string;
  FIREBASE_MEASUREMENT_ID?: string;
}

const env = typeof window !== 'undefined' ? window.env : process.env;

invariant(
  env.GRAPHQL_URI && typeof env.GRAPHQL_URI === 'string',
  '💣💥 ENV_CONFIG_ERROR: The "GRAPHQL_URI" value is not a valid string',
);

invariant(
  env.API_URI && typeof env.API_URI === 'string',
  '💣💥 ENV_CONFIG_ERROR: The "API_URI" value is not a valid string',
);

const config: Config = {
  API_URI: env.API_URI,
  BRANCH_API_KEY: env.BRANCH_API_KEY,
  BRAZE_API_KEY: env.BRAZE_API_KEY,
  GRAPHQL_URI: env.GRAPHQL_URI,
  NODE_ENV: env.NODE_ENV,
  SEGMENT_API_KEY: env.SEGMENT_API_KEY,
  SENTRY_DSN: env.SENTRY_DSN,
  SPLIT_API_KEY: env.SPLIT_API_KEY,
  LOG_LEVEL: env.LOG_LEVEL,
  FIREBASE_API_KEY: env.FIREBASE_API_KEY,
  FIREBASE_AUTH_DOMAIN: env.FIREBASE_AUTH_DOMAIN,
  FIREBASE_DATABASE_URL: env.FIREBASE_DATABASE_URL,
  FIREBASE_PROJECT_ID: env.FIREBASE_PROJECT_ID,
  FIREBASE_STORAGE_BUCKET: env.FIREBASE_STORAGE_BUCKET,
  FIREBASE_MESSAGING_SENDER_ID: env.FIREBASE_MESSAGING_SENDER_ID,
  FIREBASE_APP_ID: env.FIREBASE_APP_ID,
  FIREBASE_MEASUREMENT_ID: env.FIREBASE_MEASUREMENT_ID,
};

export { config };
